//bao migrate skip
import "bootstrap";
import template from "./bao-toggle-buttons.html";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
// own view model to get multiple binings on one page
export class ButtonToggleViewModel {
    /** Html Element which have this binding
     */
    HtmlElement: any;
    /** Toggle State
     * is used by Computed Elements
     */
    toggle = ko.observable<boolean>();
    /** Describes if this buttongroup is Mandatory or not
     */
    isMandatory = ko.observable(false);
    /** Buttons settings
     */
    Buttons = ko.observableArray<toggleButton>([
        { value: Bao.Session.GetMessage("msgYes"), css: "btn-success", long: "" },
        { value: Bao.Session.GetMessage("msgNo"), css: "btn-danger", long: "" }
    ]);
    // dont know for what and why
    btnsuccess = ko.observable(true);
    /** CSS Classes for the positive Button
     */
    ButtonPositiveCss: KnockoutComputed<string>;
    /** CSS Classes for the negative Button
     */
    ButtonNegativeCss: KnockoutComputed<string>;
    /** Text for the positive Button
     */
    ButtonPositiveText: KnockoutComputed<string>;
    /** Text for the negative Button
     */
    ButtonNegativeText: KnockoutComputed<string>;
    /** Text for the positive Button
     */
    ButtonPositiveLongText: KnockoutComputed<string>;
    /** Text for the negative Button
     */
    ButtonNegativeLongText: KnockoutComputed<string>;
    /** for readonly Binding
     */
    ReadOnly: KnockoutComputed<boolean>;
    /** option-value for readonly Binding
     */
    ReadOnlyValue: KnockoutObservable<boolean>;
    /** option-value for readonly Binding
     */
    IsDeselectableValue: KnockoutObservable<boolean>;
    constructor(element) {
        this.HtmlElement = element;
        // toggle state and value observable
        this.isMandatory.subscribe((value) => {
            $(this.HtmlElement).toggleClass("isMandatory", value == true);
        });
        this.ButtonPositiveCss = ko.pureComputed(() => {
            var cssClasses = [];
            if (this.toggle() !== true) {
                //cssClasses.push("hidden-print");
                cssClasses.push("btn-default");
            }
            else if (this.toggle() === true) {
                cssClasses.push(ko.unwrap(this.Buttons()[0].css));
                cssClasses.push("active");
            }
            return cssClasses.join(" ");
        });
        this.ButtonNegativeCss = ko.pureComputed(() => {
            var cssClasses = [];
            if (this.toggle() !== false) {
                //cssClasses.push("hidden-print");
                cssClasses.push("btn-default");
            }
            else if (this.toggle() === false) {
                cssClasses.push(ko.unwrap(this.Buttons()[1].css));
                cssClasses.push("active");
            }
            return cssClasses.join(" ");
        });
        this.ButtonPositiveText = ko.pureComputed(() => { return ko.unwrap(this.Buttons()[0].value); });
        this.ButtonNegativeText = ko.pureComputed(() => { return ko.unwrap(this.Buttons()[1].value); });
        this.ButtonPositiveLongText = ko.pureComputed(() => {
            return ko.unwrap(this.Buttons()[0]?.long);
        });
        this.ButtonNegativeLongText = ko.pureComputed(() => {
            return ko.unwrap(this.Buttons()[1]?.long);
        });
        this.ReadOnly = ko.pureComputed(() => {
            if (ko.unwrap(this.ReadOnlyValue)) {
                return true;
            }
            return false;
        });
    }
    /**
     * Funktion to initialize Binding
     */
    AddButtons() {
        this.HtmlElement.innerHTML = template;
        $(this.HtmlElement).addClass("btn-group");
        $(this.HtmlElement).addClass("toggleButtons");
    }
    SetToggle(newState: boolean) {
        // cancle if is ReadOnly
        if (this.ReadOnly()) {
            return;
        }
        // Deselect if currentValue=== new Value and IsDeselectableValue.option is true
        if (this.toggle() === newState && ko.unwrap(this.IsDeselectableValue)) {
            this.toggle(null);
            return;
        }
        this.toggle(newState);
    }
    /**
     *  Event Handler OnClickPositive
     */
    OnClickPositive: () => void = () => this.SetToggle(true);
    /**
     * Event Handler OnClickNegative
     */
    OnClickNegative: () => void = () => this.SetToggle(false);
}
ko.bindingHandlers["baoToggleButtons"] = {
    ///
    /// valueAccessor must have "value" as an observable
    ///   optional: "Buttons" as [{value:,css:},{value:,css:}]
    init: function (element, valueAccessor, allBindings, data, bindingContext) {
        // create own viewmodel for this binding
        var buttonToggleViewModel = new ButtonToggleViewModel(element);
        let options: Bindings.baoToggleButtons = valueAccessor();
        // init
        buttonToggleViewModel.AddButtons();
        // init options
        var obs = options.value;
        if (!ko.isObservable(obs)) {
            throw Error("Need observable value");
        }
        buttonToggleViewModel.toggle = obs;
        // optional: Buttons must be array of 2 objects with properties: {value,css}. 
        if (options.Buttons) {
            buttonToggleViewModel.Buttons(ko.unwrap(options.Buttons));
        }
        // optional: IsMandatory 
        if (options.IsMandatory) {
            buttonToggleViewModel.isMandatory(ko.unwrap(options.IsMandatory));
        }
        // optional: readonly
        if (options.readonly) {
            if (ko.isObservable(options.readonly)) {
                buttonToggleViewModel.ReadOnlyValue = options.readonly;
            }
            else {
                buttonToggleViewModel.ReadOnlyValue = ko.observable(options.readonly);
            }
        }
        // optional: isDeselectable
        if (options.isDeselectable) {
            if (ko.isObservable(options.isDeselectable)) {
                buttonToggleViewModel.IsDeselectableValue = options.isDeselectable;
            }
            else {
                buttonToggleViewModel.IsDeselectableValue = ko.observable(options.isDeselectable);
            }
        }
        //binding - with extra context hierarchie binding
        var childBindingContext = bindingContext.createChildContext(buttonToggleViewModel);
        ko.applyBindingsToDescendants(childBindingContext, element);
        // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor, allBindings, data, bindingContext) {
    }
};